import {Component, inject, OnInit} from '@angular/core';
import {PureOriginalsUploadService} from "../../service/pure-originals-upload.service";
import {NotificationService} from "../../service/Notification.service";

const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50 MB

@Component({
    selector: 'app-pure-originals-upload',
    templateUrl: './pure-originals-upload.component.html',
    styleUrls: ['./pure-originals-upload.component.css']
})
export class PureOriginalsUploadComponent implements OnInit {

    pureOriginalsUploadService = inject(PureOriginalsUploadService);
    private readonly notification = inject(NotificationService);

    ngOnInit() {
        this.refreshUpload();
        this.checkForChanges();
    }

    checkForChanges() {
        this.pureOriginalsUploadService.checkForChanges()
    }

    refreshUpload() {
        this.pureOriginalsUploadService.refreshUpload()
    }


    uploadBin($event: any) {
        this.pureOriginalsUploadService.resetSignal.set(false);
        const file = $event.valueOf()["fileToUpload"] as File;
        if (!this.isWithinSizeLimit(file)) return;
        this.pureOriginalsUploadService.uploadBin(file);
    }

    uploadIni($event: any) {
        this.pureOriginalsUploadService.resetSignal.set(false);
        const file = $event.valueOf()["fileToUpload"] as File;
        if (!this.isWithinSizeLimit(file)) return;
        this.pureOriginalsUploadService.uploadIni(file)
    }

    uploadAllFiles() {
        this.pureOriginalsUploadService.uploadAllFiles();
    }

    private isWithinSizeLimit(file: File | undefined): boolean {
        if (!file) return false;
        if (file.size > MAX_FILE_SIZE_BYTES) {
            this.notification.showErrorMessage(
                'File is too large. Maximum size is 50 MB.',
                'File too large'
            );
            return false;
        }
        return true;
    }
}

export class CustomPureOriginalUploadValidations {
    message: string;
    hasError: boolean;
    pureOriginalId: number;
}
